/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateHchbPatientRequestBody
 */
export interface CreateHchbPatientRequestBody {
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    request_payload: { [key: string]: any; };
}

/**
 * Check if a given object implements the CreateHchbPatientRequestBody interface.
 */
export function instanceOfCreateHchbPatientRequestBody(value: object): value is CreateHchbPatientRequestBody {
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('request_payload' in value) || value['request_payload'] === undefined) return false;
    return true;
}

export function CreateHchbPatientRequestBodyFromJSON(json: any): CreateHchbPatientRequestBody {
    return CreateHchbPatientRequestBodyFromJSONTyped(json, false);
}

export function CreateHchbPatientRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateHchbPatientRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'],
        'request_payload': json['request_payload'],
    };
}

export function CreateHchbPatientRequestBodyToJSON(json: any): CreateHchbPatientRequestBody {
    return CreateHchbPatientRequestBodyToJSONTyped(json, false);
}

export function CreateHchbPatientRequestBodyToJSONTyped(value?: CreateHchbPatientRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_id': value['lead_id'],
        'request_payload': value['request_payload'],
    };
}

